import {
  Button,
  Dialog,
  DialogContent,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { APP_ICONS } from "../../assets";
import Loader from "../../components/loader";
import TextInput from "../../components/textInput";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },
  "& .MuiPaper-root": {
    width: "550px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

let paramsData = {};
const initialInputState = {
  name: "",
  email: "",
  phone: "",
  vendorShare: "",
  bbShare: "",
  customerShare: "",
  password: "",
  confirmPassword: "",
};

const CreateVendorModal = forwardRef(
  ({ handleCreateVendor, isLoading }, ref) => {
    const [open, setOpen] = useState(false);
    const [inputVall, setInputVall] = useState(initialInputState);
    const [errors, setErrors] = useState({});

    useImperativeHandle(ref, () => ({
      openDialog(params) {
        paramsData = params;
        setOpen(true);
      },
      closeDialog() {
        setOpen(false);
        setInputVall(initialInputState);
        setErrors({});
      },
    }));

    const closeDialog = () => {
      setOpen(false);
      setInputVall(initialInputState);
      setErrors({});
    };

    const validateFields = () => {
      let newErrors = {};
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const phoneRegex = /^[0-9]+$/;

      Object.keys(inputVall).forEach((field) => {
        if (!inputVall[field]) {
          newErrors[field] = `${
            field.charAt(0).toUpperCase() + field.slice(1)
          } Cannot Be Empty`;
        }
      });

      if (inputVall.email && !emailRegex.test(inputVall.email)) {
        newErrors.email = "Invalid Email Format";
      }
      if (inputVall.phone && !phoneRegex.test(inputVall.phone)) {
        newErrors.phone = "Phone Number Must Contain Only Numbers";
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (field, value) => {
      if (field === "phone") {
        value = value.replace(/\D/g, "");
      }

      if (field === "vendorShare") {
        let vendorValue = parseInt(value, 10);
        if (isNaN(vendorValue)) vendorValue = 0;
        if (vendorValue > 100) vendorValue = 100;

        let remaining = 100 - vendorValue;
        let splitShare = remaining / 2;

        setInputVall({
          ...inputVall,
          vendorShare: vendorValue.toString(),
          bbShare: splitShare.toString(),
          customerShare: splitShare.toString(),
        });
      } else {
        setInputVall({ ...inputVall, [field]: value });
      }
    };

    const handleSubmit = () => {
      if (validateFields()) {
        handleCreateVendor(inputVall);
      }
    };

    return (
      <BootstrapDialog onClose={closeDialog} open={open}>
        <DialogContent>
          <Typography
            fontSize={"1.375rem"}
            fontWeight={600}
            textAlign={"center"}
            color={"primary.light"}
          >
            Create New Vendor
          </Typography>

          {Object.keys(inputVall).map((field) => (
            <div key={field}>
              <InputLabel>
                {field.charAt(0).toUpperCase() +
                  field
                    .slice(1)
                    .replace(/([A-Z])/g, " $1")
                    .trim()}
              </InputLabel>
              <TextInput
                sx={{ flex: 1, mb: 2 }}
                placeholder={`Enter ${
                  field.charAt(0).toUpperCase() + field.slice(1)
                }`}
                value={inputVall[field]}
                onChange={(e) => handleInputChange(field, e.target.value)}
                disabled={field === "bbShare" || field === "customerShare"}
              />
              {errors[field] && (
                <Typography color="error">{errors[field]}</Typography>
              )}
            </div>
          ))}

          <Stack direction="row" alignItems="center" gap={1} mt={4}>
            <Button
              variant="custom_outlined"
              onClick={handleSubmit}
              endIcon={
                <img
                  src={APP_ICONS.fileSaveIconBlue}
                  width={22}
                  alt="Save Icon"
                />
              }
            >
              Create
            </Button>
            <Button variant="suspend_button" onClick={closeDialog}>
              Discard
            </Button>
          </Stack>
        </DialogContent>
        <Loader isLoading={isLoading} />
      </BootstrapDialog>
    );
  }
);

export default CreateVendorModal;
